<template>
  <div class="flex-row d-flex align-center">
    <v-icon color="icon-secondary" class="handle pr-3"
      >$vuetify.icons.DragHandle</v-icon
    >
    <v-checkbox v-model="valueLazy" hide-details class="ma-0 pa-0" label="">
      <template #label>
        <div style="word-break: break-word">
          <slot />
        </div>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valueLazy: this.value
    };
  },
  watch: {
    value(val) {
      this.valueLazy = val;
    },
    valueLazy(val) {
      if (this.value === val) {
        return;
      }

      this.$emit("input", val);
    }
  }
};
</script>
